/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import {permissionObj} from "../../../../../Helpers/permission";
import CafeteriaTableApp from "../Functionality/CafeteriaTableApp";
import CustomExpandableTable from "../../../../../components/table/CustomExpandableTable";
import RenderExpandedRow from "./RenderExpandedRow";
import NotInformation from "../../../../../components/NotInformation";
import CustomButtonLink from "../../../../../components/buttons/CustomButtonLink";
import routes from "../../../../../Routes/routes";

const CafeteriaTable = (props) => {
    const {
        contractorId,
        selectedList,
        searchElement,
        setSearchElement,
        supplierId,
        setSearch,
        setSimpleSearch,
        setBodyForExport,
        setSelectedList,
        modified,
        setModified,
        setIsAllChecked,
        onDeleteItem,
        option
    } = props;

    const {
        t,
        DEV,
        permission,
        tableId,
        searchId,
        pagination,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        results,
        setResults,
        rowsPerPage,
        columns,
        handleRowExpand
    } = CafeteriaTableApp({
        searchElement,
        selectedList,
        setSelectedList,
        modified,
        setModified,
        setBodyForExport,
        setIsAllChecked,
        onDeleteItem,
        option
    });

    return (
        <>
            <SearchSimple
                id={searchId}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={contractorId}
                supplierId={supplierId}
            />

            {
                results?.content?.length > 0 ?
                    <>
                        {/**Done*/}
                        <CustomExpandableTable
                            id={tableId}
                            columns={columns}
                            rows={results?.content || []}
                            renderExpandedRow={RenderExpandedRow}
                            renderOptionsMenu={(DEV ||
                                permission.includes(permissionObj?.WEB_FOODIE_CAFETERIA_UPDATE) ||
                                permission.includes(permissionObj?.WEB_FOODIE_CAFETERIA_DELETE)) ? getActionsButtons : false
                            }
                            onRowExpand={handleRowExpand}
                            selectedList={selectedList}
                            handleCheckboxChange={handleCheckboxChange}
                            handleDeleteAll={handleDeleteAll}
                            rowsPerPage={rowsPerPage}
                            checkbox={(DEV || permission.includes(permissionObj?.WEB_FOODIE_CAFETERIA_DELETE))}
                        />
                        {pagination()}
                    </>
                :

                <NotInformation
                    card={true}
                    text={ t('no_cafeterias')}
                    showButton={((DEV || permission?.includes(permissionObj?.WEB_FOODIE_CAFETERIA_CREATE)))}
                    buttonId={'btn_ct_link_create_cafeterias'}
                    buttonUrl={routes.foodieCafeteria.create}
                    buttonTrans={'create_new_cafeteria'}
                    searchElement={searchElement}
                />
            }
        </>
    );
};
export default CafeteriaTable;
